import React from 'react';
import { Derivation } from '../interfaces/Derivation';

interface DerivationDetailsProps {
  selectedDerivation?: Derivation | null;
  onDeselect: () => void;
  isLoading?: boolean;
}

export const DerivationDetails: React.FC<DerivationDetailsProps> = ({
  selectedDerivation,
  onDeselect,
  isLoading = false,
}) => {
  if (isLoading || !selectedDerivation) {
    return (
      <div className='w-full p-4 bg-orange-100 rounded-lg shadow-sm border border-orange-200 animate-pulse'>
        <div className='h-6 bg-orange-200 rounded w-1/3'></div>
      </div>
    );
  }

  const dateValue = selectedDerivation.dt
    ? new Date(selectedDerivation.dt)
    : null;
  const formattedDate =
    dateValue && !isNaN(dateValue.getTime())
      ? dateValue.toLocaleDateString('en-GB')
      : 'Fecha no disponible';

  const senderName = selectedDerivation.from || 'Desconocido';

  return (
    <div className='w-full p-4 bg-orange-200 rounded-lg shadow-md flex items-center justify-between'>
      <p className='font-semibold text-lg'>
        {`${formattedDate} - ${senderName}`}
      </p>
      <button
        onClick={onDeselect}
        className='text-gray-500 hover:text-gray-700 text-xl font-bold p-1'
      >
        ×
      </button>
    </div>
  );
};
